<template>
  <input
    type="checkbox"
    :id="identity"
    :name="name"
    :disabled="isDisabled"
    :autocomplete="autocomplete"
    :class="inputCssClass"
    v-model="checked"
    @change="update"
  />
</template>
<script>
import BaseCheckboxInput from '@ssdcode/vue-form/src/components/Form/Inputs/Input/Checkbox/BaseCheckboxInput';
export default {
  name: 'CheckBox',
  mixins: [BaseCheckboxInput],
};
</script>
